import { Component } from 'react'
import { Register, TabMedRecordsWithAudit, TabPersonalWithAudit, TabRouteWithAudit } from '@src/modules/monitoring/components'
import { REGISTER_COLUMNS, URLS } from '@src/constants'
import config from '@src/config'
import { TabStatusWithAudit } from './TabStatus'

export class RegisterSszOnmk extends Component {
  get basepath () {
    return URLS.MONITORING__SSZ__ONMK
  }

  get navTitle () {
    return 'Реестр пациентов с ОНМК'
  }

  get columns () {
    return [
      { type: REGISTER_COLUMNS.FULLNAME, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.SNILS, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.BIRTH_DATE, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.GENDER_ID, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.DIAGNOSIS, settings: { column: { enabled: true } } },
    ]
  }

  get tabs () {
    return [
      TabStatusWithAudit,
      TabMedRecordsWithAudit,
      TabPersonalWithAudit,
      ...(config.app.modules.enabled.monitoring_routes ? [TabRouteWithAudit] : []),
    ]
  }

  render () {
    return <Register
      list_type='6'
      columns={this.columns}
      basepath={this.basepath}
      navTitle={this.navTitle}
      tabs={this.tabs}
    />
  }
}
